import React, { } from 'react';
import { useSelector } from 'react-redux';
import { Tabs, CapsuleTabs, Badge } from 'antd-mobile';
import { useAuth, useTranslateContext } from 'fennec-ui';
import { item, level } from '../../../common/Tool';
import { useMatch } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { TabBar } from 'antd-mobile';


var _ = require('lodash');

export default function MenuLevelThree({ menu }) {
    const auth = useAuth();
    let navigate = useNavigate();
    const role_by_id = useSelector(state => state.home.role_by_id);
    const status = useSelector(state => state.home.status);
    const notify = useSelector(state => state.home.notify);
    const t = useTranslateContext();

    let _menu = level(menu, "", role_by_id)

    let match = useMatch({
        path: "/app/:one/:two/:three",
        caseSensitive: false,
        end: false
    })

    const l = (element, key) => {
        const count = (element.badge) ? element.badge(element).count : 0;

        const title = (element) => {
            if (key === match?.params?.three) {
                return (<span>{element.name} {(count)? <Badge content={count} />:""}</span>);
            }
            return (<span>{element.name} {(count)? <Badge content={count} />:""}</span>);
        };
        return {
            title: <span>{title(element)}</span>,
            key: key,
            // children: element.component,
        };
    }
    const elements = _menu.map((element, index) => {
        const key = element.uuid || element.key || index;
        return l(element, key)
    })

    const renderTabContent = (tab) => {
        return (
            <CapsuleTabs.Tab title={tab.title} key={tab.key}>
                {(tab.children) ? tab.children() : undefined}
            </CapsuleTabs.Tab>
        )
    };

    return (
        <>
            <div className={"menu-level-three"} style={{ backgroundColor: 'white' }}>
                <CapsuleTabs
                    defaultActiveKey={match?.params?.three}
                    activeKey={match?.params?.three}
                    style={{
                        "--adm-color-primary":"#5e5e5e",
                        "--adm-font-size-7":"14px"
                        // "--active-line-color": "#001529",
                        // "--active-title-color": "#001529",
                        // "--title-font-size": "13px",
                        // "--content-padding": "0px",
                    }}
                    onChange={(key) => {
                        navigate(key);
                    }}
                >
                    {elements.map(e => renderTabContent(e))}
                </CapsuleTabs>
            </div>
        </>
    )
}